var map = {
	"./point-1.svg": 317,
	"./point-2.svg": 835,
	"./point-3.svg": 909,
	"./point-4.svg": 396,
	"./point-5.svg": 229,
	"./point-6.svg": 266,
	"./settings.svg": 166,
	"./user.svg": 362,
	"./world.svg": 722
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;